/**
 * Initiale leere Daten – keine Demo-Daten.
 * Mit API werden Daten vom Server geladen, ohne API startet die App leer.
 */
export const initialCompanySettings = {
  companyName: '',
  owner: '',
  address: '',
  zipCity: '',
  taxId: '',
  vatId: '',
  isSmallBusiness: false,
  bankName: '',
  iban: '',
  bic: '',
  email: '',
  phone: '',
  website: '',
  registry: '',
  logoUrl: '/Nextbill Logo.png',
  primaryColor: '#2563eb',
  creditorId: '',
  invoiceNumberPrefix: 'RE',
  subscriptionPaymentDays: 14,
  subscriptionAutoStatus: 'draft',
  autoRunSubscriptions: true,
  autoRunReminders: true,
  reminderDays: 7,
  reminderMaxLevel: 3,
  reminderFee1: 5,
  reminderFee2: 10,
  reminderFee3: 15,
  contractAlertDays: 30,
  datevProfileName: 'Standard',
  datevRevenueAccount: '8400',
  datevRevenueAccount19: '8400',
  datevRevenueAccount7: '8300',
  datevRevenueAccount0: '8125',
  datevDebitorAccount: '10000',
  datevDelimiter: ';',
  emailSubjectQuote: 'Angebot {Dokumentnummer} von {Firma}',
  emailTemplateQuote: '',
  emailSubjectInvoice: 'Rechnung {Dokumentnummer} von {Firma}',
  emailTemplateInvoice: '',
  emailSubjectReminder: '{Mahnstufe}. Mahnung {Dokumentnummer} von {Firma}',
  emailTemplateReminder: '',
};

export const initialCustomers = [];

export const initialInvoices = [];

export const initialQuotes = [];

export const initialSubscriptions = [];
